export const Logo = ({ className = "h-14 sm:h-16" }) => (
  <img src="/images/jem-logo-dark.png" alt="JEM — Journey Empower Motivate" width="646" height="308"
    className={`w-auto ${className}`} data-testid="jem-logo" />
);
